import { Client } from "./Client";

export class LoginService {
  constructor(private client: Client) {}

  async login(username: string, password: string) {
    return await this.client.login(username, password);
  }

  async getAuthConfig() {
    return await this.client.getAuthConfig();
  }

  async entraExchange(code: string) {
    return await this.client.entraExchange(code);
  }

  async updateUserPreferences(prefs: { plume_animation_enabled?: boolean }) {
    return await this.client.updateUserPreferences(prefs);
  }
}
